import React from 'react';

// Status pills as seen in the app: COBRADO / PENDIENTE / VENCIDO.
const TONES = {
  paid:    { color: 'var(--status-paid)', bg: 'var(--status-paid-bg)' },
  pending: { color: 'var(--status-pending)', bg: 'var(--status-pending-bg)' },
  overdue: { color: 'var(--status-overdue)', bg: 'var(--status-overdue-bg)' },
  neutral: { color: 'var(--text-muted)', bg: 'rgba(148,163,184,0.14)' },
  info:    { color: 'var(--accent-blue)', bg: 'var(--accent-blue-soft)' },
};

/**
 * Badge — small uppercase status pill (COBRADO / PENDIENTE / VENCIDO).
 */
export function Badge({ tone = 'neutral', children, solid = false, style = {}, ...rest }) {
  const t = TONES[tone] || TONES.neutral;
  const styles = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '4px 10px',
    borderRadius: 'var(--radius-pill)',
    background: solid ? t.color : t.bg,
    color: solid ? '#fff' : t.color,
    fontFamily: 'var(--font-sans)',
    fontWeight: 'var(--fw-extrabold)',
    fontSize: 'var(--fs-xs)',
    letterSpacing: 'var(--ls-overline)',
    textTransform: 'uppercase',
    lineHeight: 1,
    whiteSpace: 'nowrap',
    ...style,
  };
  return <span style={styles} {...rest}>{children}</span>;
}
